import { ButtonHTMLAttributes, FC, HTMLAttributes, ReactNode } from 'react';

import Tabs from '../Tabs/Tabs';

export interface TabsWithContentProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  activeClass?: string;
  tabs: { label: string; component: ReactNode }[];
  value?: number;
  onChange?(value: number): any;
  btnProps?: ButtonHTMLAttributes<HTMLButtonElement>;
}

const TabsWithContent: FC<TabsWithContentProps> = ({
  tabs = [],
  activeClass,
  value,
  onChange,
  btnProps,
  ...props
}) => {
  const body = tabs[value || 0]?.component;

  return (
    <div {...props}>
      <Tabs
        value={value}
        onChange={onChange}
        tabs={tabs}
        normalClass={activeClass}
        activeClass={activeClass}
        btnProps={btnProps}
      />
      {body}
    </div>
  );
};

export default TabsWithContent;
